import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import React from 'react'
import type { UseFormMethods } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import styled from 'styled-components'

import { UserDataFormComponentProps } from '../../clickwrap/types'
import { CoveredEntityFormFieldValues } from './types'

type UseFormMethodsTyped = UseFormMethods<CoveredEntityFormFieldValues>

export interface CoveredEntityRadioButtonsProps extends UserDataFormComponentProps {
  control: UseFormMethodsTyped['control']
  errors: UseFormMethodsTyped['errors']
}

const CoveredEntityRadioButtons: React.FC<CoveredEntityRadioButtonsProps> = ({
  control,
  errors,
  disabled,
}) => {
  return (
    <Controller
      control={control}
      name="hipaaCoveredEntity"
      render={({ onChange, onBlur, value, name }) => (
        <FormControl
          error={!!errors['hipaaCoveredEntity']}
          className="covered-entity-fieldset"
          component="fieldset"
        >
          <FormLabel className="covered-entity-question">
            <Typography variant="body2">Are you a Covered Entity under HIPAA?*</Typography>
          </FormLabel>
          <RadioGroup
            className="covered-entity-radio-group"
            name={name}
            onBlur={onBlur}
            onChange={(e) => onChange(e.target.value)}
            row
            value={value}
          >
            <FormControlLabel
              className="covered-entity-radio"
              control={<Radio checkedIcon={<CheckCircleIcon />} />}
              disabled={disabled}
              label="No"
              value="no"
            />
            <FormControlLabel
              className="covered-entity-radio"
              control={<Radio checkedIcon={<CheckCircleIcon />} />}
              disabled={disabled}
              label="Yes"
              value="yes"
            />
          </RadioGroup>
        </FormControl>
      )}
      rules={{ required: true }}
    />
  )
}

const StyledCoveredEntityRadioButtons = styled(CoveredEntityRadioButtons)(({ theme }) => ({
  '.covered-entity-fieldset': {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '24pt',
  },
  '.covered-entity-question': {
    marginRight: '15px',
    color: theme.colors.coolGray.cool700,
  },
  '.covered-entity-radio-group': {
    flexWrap: 'nowrap',
  },
  '.covered-entity-radio': {
    border: '1px solid #E5E5E5',
    margin: '0',
    overflow: 'hidden',
    width: '100px',
    '&:first-of-type': {
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },
    '&:last-of-type': {
      borderLeft: 'none',
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
    },
    '& .MuiRadio-root': {
      padding: '9px 6px 9px',
    },
    '&.Mui-disabled': {
      // Border color matches the old palette from the standalone cart app
      // and should be unified in later refactors.
      borderColor: 'rgba(0, 0, 0, 0.26)',
    },
    '& .MuiRadio-colorSecondary': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: theme.colors.coolGray.cool100,
    },
    '@media(min-width: 375px)': {
      width: '119px',
    },
  },
}))

export default StyledCoveredEntityRadioButtons
